import actions from './actions';
import getCommentReducer from '../../../../../../../components/comments/reducer';

export default getCommentReducer(actions);
